import * as React from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import Pagination from '@mui/material/Pagination'
import TableRow from '@mui/material/TableRow'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Link from '@mui/material/Link'
import { styled } from '@mui/material/styles'
// import Tooltip from '@mui/material/Tooltip'
import Tooltip from 'components/Common/ToolTip/InfoTooltip'
import { Typography, Box, Link as LinkText } from '@mui/material'
import Chip from '@mui/material/Chip'
import './index.css'
import MonitorButton from './monitorButton'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector, useDispatch } from 'react-redux'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import {
  clearFullSearch,
  updateSelectedBusiness,
  handleNotifications,
  fetchFetchCompany,
  updateSearchCriteria,
  toggleSearchError,
} from 'store/actions/businessListingActions'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import KeyboardControlKeyIcon from '@mui/icons-material/KeyboardControlKey'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import { useNavigate } from 'react-router-dom'
import SelectField from '../../../components/Common/SelectBox'
import MenuItem from '@mui/material/MenuItem'
import Grid from '@mui/material/Grid'
import { BusinessAvatarSearch } from 'components/MyBusiness/BusinessAvatarSearch'

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const StyledChip = styled(Chip)(({ theme }) => ({
  fontSize: '12px',
  '& span': {
    fontSize: '12px',
  },
}))

const TooltipContent = () => (
  <Box>
    <Typography variant="body2" color="white">
      This business has been successfully claimed and verified by Markaaz. To learn more, see “Verification” in
      Markaaz’s&nbsp;
      <Link
        sx={{ whiteSpace: 'nowrap', textDecorationColor: 'white !important' }}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        href="https://markaaz.com/terms-and-conditions/"
      >
        <Typography component="span" variant="body2B" color="white">
          Terms and Conditions
        </Typography>
      </Link>
      .
    </Typography>
  </Box>
)

function getYear(row) {
  return Number(row.established) || row.established_year || row.details.establishedYear || ''
}

const SearchResults = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const businessReducer = useSelector(state => state.businessReducer)
  const { searchList, showSpinner, snakBarData, searchCriteria, error } = businessReducer
  const { matched, businessProfiles } = searchList || { matched: 0, businessProfiles: [] }
  const [rowsPerPage, setRowsPerPage] = React.useState(searchCriteria.rowsPerPage)
  const itemsPerPage = [20, 50, 100]
  const itemsOptions = itemsPerPage.map(value => {
    const label = value
    return { label, value }
  })

  const handleChangePage = (event, newPage) => {
    const skip = {
      ...searchCriteria,
      skip: newPage === 0 ? 0 : newPage * rowsPerPage - rowsPerPage,
      pageNo: newPage - 1,
    }
    updateSearchCriteria(dispatch, skip)
    fetchFetchCompany(dispatch, skip)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value)
    const skip = {
      ...searchCriteria,
      skip: 0,
      rowsPerPage: +event.target.value,
      pageNo: 0,
    }
    updateSearchCriteria(dispatch, skip)
    fetchFetchCompany(dispatch, skip)
  }

  const getBusinessFullAddress = model => {
    const parts = [
      model.details.addressStreet || model.address,
      model.details.addressCity || model.city,
      model.details.addressState || model.state || model.region,
      model.details.addressZip || model.zip,
      model.details.addressCountry || model.country,
    ]

    return parts.filter(part => part).join(', ')
  }
  const handleRowClick = row => {
    updateSelectedBusiness(dispatch, row)
    navigate('/details')
  }
  const handleClose = () => {
    handleNotifications(dispatch, {
      open: false,
      message: '',
      type: '',
    })
  }
  const findSorting = order => {
    if (!order) {
      return 'asc'
    } else if (order === 'asc') {
      return 'desc'
    } else {
      return ''
    }
  }
  const handleSorting = field => {
    const sort = {
      ...searchCriteria,
      sortBy: {
        field: field,
        order: findSorting(searchCriteria.sortBy.order),
      },
    }
    updateSearchCriteria(dispatch, sort)
    fetchFetchCompany(dispatch, sort)
  }

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom="10px">
        <Typography variant="caption" style={{ color: '#66668F' }}>
          Can't find your business? &nbsp;
          <LinkText
            underline="hover"
            onClick={() => {
              updateSelectedBusiness(dispatch, null)
              navigate('/claim')
            }}
            style={{ cursor: 'pointer' }}
          >
            <Typography component="span" variant="button3" color="secondary">
              Click Here
            </Typography>
          </LinkText>
          &nbsp; to create a business profile.
        </Typography>
        {businessReducer.searchList && (
          <LinkText underline="hover" sx={{ cursor: 'pointer' }} onClick={() => clearFullSearch(dispatch)}>
            <Typography component="span" variant="button3" color="secondary">
              Clear Search
            </Typography>
          </LinkText>
        )}
      </Box>
      <Paper sx={{ width: '100%', overflow: 'hidden', marginBottom: '20px' }} elevation={3}>
        {/* <TableContainer sx={{ maxHeight: 380 }}> */}
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell width="530px">
                  <Box
                    display="flex"
                    alignItems="center"
                    gridGap="7px"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSorting('name')}
                  >
                    <Typography variant="body2M">Business Name</Typography>&nbsp;
                    {searchCriteria.sortBy.field === 'name' ? (
                      searchCriteria.sortBy.order === 'asc' ? (
                        <KeyboardControlKeyIcon sx={{ fontSize: '16px' }} />
                      ) : searchCriteria.sortBy.order === 'desc' ? (
                        <KeyboardArrowDownIcon sx={{ fontSize: '16px' }} />
                      ) : (
                        <UnfoldMoreIcon sx={{ fontSize: '16px' }} />
                      )
                    ) : (
                      <UnfoldMoreIcon sx={{ fontSize: '16px' }} />
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Typography variant="body2M">Verified by Markaaz</Typography>&nbsp;
                    <Tooltip content={<TooltipContent />} />
                    {/* <Tooltip
                      placement="top"
                      arrow
                      title={
                        <Box textAlign="center">
                          <Typography variant="subtitle1" className="text-sm">
                            This business has been successfully claimed by a user and verified by Markaaz. See Section
                            10.1 of the{' '}
                            <a
                              target="_blank"
                              style={{ color: 'white', textDecoration: 'underline' }}
                              rel="noreferrer"
                              href="https://markaaz.com/terms-and-conditions/"
                            >
                              <b>Terms and Conditions</b>
                            </a>{' '}
                            for more information.
                          </Typography>
                        </Box>
                      }
                    >
                      <IconButton>
                        <InfoOutlinedIcon sx={{ fontSize: 25 }} />
                      </IconButton>
                    </Tooltip> */}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box
                    display="flex"
                    alignItems="center"
                    gridGap="7px"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSorting('year')}
                  >
                    <Typography variant="body2M">Established</Typography>&nbsp;
                    {searchCriteria.sortBy.field === 'year' ? (
                      searchCriteria.sortBy.order === 'asc' ? (
                        <KeyboardControlKeyIcon sx={{ fontSize: '16px' }} />
                      ) : searchCriteria.sortBy.order === 'desc' ? (
                        <KeyboardArrowDownIcon sx={{ fontSize: '16px' }} />
                      ) : (
                        <UnfoldMoreIcon sx={{ fontSize: '16px' }} />
                      )
                    ) : (
                      <UnfoldMoreIcon sx={{ fontSize: '16px' }} />
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography variant="body2M">Follow</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="searchPage">
              {!showSpinner &&
                businessProfiles.slice(0, rowsPerPage).map(row => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      sx={{ '& > *': { borderTop: '1px solid #CEE4F5 !important', cursor: 'pointer' } }}
                    >
                      <TableCell onClick={() => handleRowClick(row)}>
                        <Box display="flex" alignItems="center" gap="20px">
                          <BusinessAvatarSearch model={row} width={65} height={65} />
                          <Box>
                            <Typography variant="body1B" className="primaryTitle">
                              {row.details.businessName || row.company}
                            </Typography>
                            <br />
                            <Typography variant="body2M">{row.details.category || row.sic}</Typography>
                            <Typography variant="body2" color="#66668F">
                              {getBusinessFullAddress(row)}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell onClick={() => handleRowClick(row)}>
                        {row.isClaimed ? (
                          <StyledChip
                            className="customChip px-4 enabled"
                            icon={<CheckCircleIcon sx={{ color: '#fff !important', marginLeft: '-5px !important' }} />}
                            label="Claimed"
                          />
                        ) : (
                          <StyledChip
                            className="customChipdisabled disabled"
                            icon={
                              <FontAwesomeIcon
                                icon={faTimesCircle}
                                sx={{ color: '#9292af !important', marginLeft: '10px !important' }}
                              />
                            }
                            label="Not Claimed"
                          />
                          // <Box display="flex" alignItems="center" gridGap="7px">
                          //   <HighlightOffIcon sx={{ fontSize: '18px' }} />
                          //   <Typography variant="body2">Not Claimed</Typography>
                          // </Box>
                        )}
                      </TableCell>
                      <TableCell onClick={() => handleRowClick(row)}>
                        <Typography variant="body2">{getYear(row)}</Typography>
                      </TableCell>
                      <TableCell>
                        <MonitorButton company={row} />
                      </TableCell>
                    </TableRow>
                  )
                })}
              {(!businessProfiles.length || showSpinner) && (
                <TableRow>
                  <TableCell colSpan={4}>
                    {!businessProfiles.length && !showSpinner && (
                      <Box minHeight="260px" display="flex" justifyContent="center" gap="7px" alignItems="center">
                        <InfoOutlinedIcon sx={{ fontSize: '16px', color: '#0099FF' }} />
                        <Typography variant="body2B">No Results found</Typography>
                      </Box>
                    )}
                    {showSpinner && (
                      <Box minHeight="260px">
                        <Stack spacing={1}>
                          <Skeleton variant="rectangular" height={90} />
                          <Skeleton variant="rectangular" height={80} />
                          <Skeleton variant="rectangular" height={80} />
                        </Stack>
                      </Box>
                    )}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {matched !== 0 && (
        <Grid container>
          <Grid item xs={9.5}>
            <Box display="flex" justifyContent="center">
              <Pagination
                count={Math.ceil(matched / rowsPerPage)}
                page={searchCriteria.pageNo + 1}
                color="secondary"
                onChange={handleChangePage}
                sx={{ marginTop: '10px' }}
              />
            </Box>
          </Grid>
          <Grid item xs={1}>
            <SelectField onChange={handleChangeRowsPerPage} value={rowsPerPage} borderLess>
              {itemsOptions.map(item => (
                <MenuItem
                  className={'option'}
                  key={item.value}
                  value={item.value}
                  sx={{ borderRadius: '5px', color: '#66668f' }}
                >
                  <span className={'option'}>{item.label}</span>
                </MenuItem>
              ))}
            </SelectField>
          </Grid>
          <Grid item xs={1.5} alignSelf="center">
            <Typography variant="body2" color="#66668F" marginLeft="15px">
              items per page
            </Typography>
          </Grid>
        </Grid>
      )}
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={snakBarData.open}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert role="alert" onClose={handleClose} severity={snakBarData.type} sx={{ width: '100%', fontSize: '14px' }}>
          {snakBarData.message}
        </Alert>
      </Snackbar>
      {
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={error}
          autoHideDuration={5000}
          onClose={() => toggleSearchError(dispatch, false)}
        >
          <Alert
            role="alert"
            onClose={() => toggleSearchError(dispatch, false)}
            severity="error"
            sx={{ width: '100%', fontSize: '14px' }}
          >
            {error}
          </Alert>
        </Snackbar>
      }
    </>
  )
}

export default SearchResults
